import React from "react";
import WorkBlock from "./WorkBlock";

const adjustColor = (hex, index) => {
  const clean = String(hex || "").replace("#", "");
  const source = clean.length === 6 ? clean : "bfa58a";
  const value = Number.parseInt(source, 16);
  const r = (value >> 16) & 255;
  const g = (value >> 8) & 255;
  const b = value & 255;
  const shift = (index % 4) * 22;
  const nr = Math.max(0, Math.min(255, r + (index % 2 === 0 ? shift : -shift)));
  const ng = Math.max(0, Math.min(255, g + (index % 2 === 1 ? shift : -shift / 2)));
  const nb = Math.max(0, Math.min(255, b - shift / 2));
  return `rgb(${Math.round(nr)}, ${Math.round(ng)}, ${Math.round(nb)})`;
};

const CalendarCell = ({ entries, memberColor, selected, onCellClick, onEntryClick }) => (
  <div
    className={`cell ${selected ? "selected-slot" : ""}`.trim()}
    onClick={onCellClick}
    role="button"
    tabIndex={0}
    onKeyDown={event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onCellClick();
      }
    }}
  >
    {Array.isArray(entries) && entries.map((entry, index) => (
      <WorkBlock
        key={entry.publicId || entry.id || `${entry.member}-${entry.start}-${index}`}
        entry={entry}
        memberColor={adjustColor(memberColor, index)}
        overlapIndex={index}
        overlapCount={entries.length}
        slotMinutes={15}
        onClick={() => onEntryClick(entry)}
      />
    ))}
  </div>
);

export default CalendarCell;
